import { Component, ViewChild, inject } from '@angular/core';

import { LoginComponent } from '../login.component';
import { LoginDesktopCredentialsStepComponent } from './credentials-step/login-desktop-credentials-step.component';
import { LoginDesktopMfaStepComponent } from './mfa-step/login-desktop-mfa-step.component';

@Component({
  selector: 'app-login-desktop-view',
  templateUrl: './login-desktop-view.component.html',
  styleUrls: ['../shared-styles/login-device-view.component.scss'],
  standalone: false,
})
export class LoginDesktopViewComponent {
  public readonly login = inject(LoginComponent);

  @ViewChild(LoginDesktopCredentialsStepComponent) private credentialsStep?: LoginDesktopCredentialsStepComponent;
  @ViewChild(LoginDesktopMfaStepComponent) private mfaStep?: LoginDesktopMfaStepComponent;

  public focusCredentialInput(field: 'email' | 'password'): void {
    if (this.credentialsStep) {
      this.credentialsStep.focusCredentialInput(field);
      return;
    }

    setTimeout(() => this.credentialsStep?.focusCredentialInput(field));
  }

  public focusMfaInput(index: number): void {
    if (this.mfaStep) {
      this.mfaStep.focusMfaInput(index);
      return;
    }

    setTimeout(() => this.mfaStep?.focusMfaInput(index));
  }
}
